/* eslint-disable import/no-anonymous-default-export */
export default (plants = [], action) => {
    switch (action.type) {
        case 'DELETE_PLANT':
            return plants.filter((plant) => plant._id !== action.payload );
        case 'UPDATE_PLANT':
            return plants.map((plant) => plant._id === action.payload._id ? action.payload : plant );
        case 'FETCH_ALL_PLANT':
            return action.payload;
        case 'CREATE_PLANT':
            return [...plants, action.payload];
        default:
            return plants;
    }
}